export const grid = {
  gutterDesktop: '30px',
  gutterTablet: '20px',
  gutterPhone: '16px',
  paddingDesktop: '30px',
  paddingTablet: '20px',
  paddingPhone: '16px'
}
